import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=4a9ee48d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9ee48d"]])

export default __exports__